<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col-12">
        <p>
          Use the following to establish those Vehicle Makes and Models (years) you wish to not scrub. If configured, this will trigger and "no scrub"
          email notification.
        </p>
      </div>
    </div>
    <!-- Listing Actions -->
    <div class="table-responsive">
      <div class="row custom-row">
        <div class="col-1">
          <button class="btn btn-primary btn-small mb-2" @click="add">Add</button>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-4">
              <z-select v-model="filter" label="Make" :options="vehicles" :inline="true" @change="refreshList" />
            </div>
            <div class="col">
              <div class="custom-show-checkbox">
                <input v-model="showInactive" type="checkbox" class="custom-checkbox" @change="refreshList" />
                <span class="ml-2">Show Inactive?</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3"></div>
      </div>
      <!-- Listing -->
      <div v-show="loading.noScrubList" class="listingWrapper">
        <div class="custom-spinner"><i class="fas fa-spinner fa-spin"></i></div>
      </div>
      <div v-show="!loading.noScrubList" class="listingWrapper">
        <z-table
          v-model="noScrubList"
          class="table table-bordered table-striped"
          :is-single-row-detail="false"
          sort-on="sort"
          sort-dir="asc"
          :columns="tableColumnsName"
          @sort="setOrder"
        >
          <template #tbody="props">
            <td class="custom-column-60">
              <a href="#" @click="edit(props.row)">edit</a>
            </td>
            <td>{{ props.row.vehicleMakeName }}</td>
            <td>{{ props.row.vehicleModel }}</td>
            <td class="custom-column-100 text-center">{{ props.row.yearStart }}</td>
            <td class="custom-column-80 text-center">{{ props.row.yearEnd }}</td>
            <td>{{ props.row.reason }}</td>
            <td class="custom-column-60 text-center">
              {{ props.row.isInactive ? 'Y' : '' }}
            </td>
          </template>
          <template #empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <!-- Dialogs -->
    <dialog-no-scrub v-model="actionNoScrub" @closing="closeModal" @saved="savedNoScrub" />
    <confirm-delete
      v-model="actionDelete"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      @closing="closeModal"
      @proceed="performDelete"
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTable from '@/components/utilities/elements/Table.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogNoScrub from '@/components/adasmatrix/dialog-no-scrub.vue'
export default {
  name: 'NoScrub',
  components: {
    ZTable,
    ZSelect,
    ConfirmDelete,
    DialogNoScrub
  },
  data() {
    return {
      actionNoScrub: null,
      actionDelete: null,
      confirmTitle: 'Delete this No Scrub Item?',
      confirmAction: 'Delete',
      confirmQuestion: 'Are you sure you wish to Delete this No Scrub item?',
      showInactive: false,
      filter: '-9999',
      orderBy: 'vehicleMake',
      sortBy: 'asc'
    }
  },
  async mounted() {
    this.filter = '-9999'
    this.orderBy = 'vehicleMake'
    this.sortBy = 'asc'
    this.showInactive = false
    await this.getList()
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'lookups', 'noScrubList']),
    tableColumnsName() {
      return [
        {
          field: 'adasNoScrubList',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'vehicleMakeName',
          label: 'Make',
          sortable: true
        },
        {
          field: 'vehicleModel',
          label: 'Model',
          sortable: true
        },
        {
          field: 'yearStart',
          label: 'Year Start',
          sortable: false,
          class: 'custom-column-100 text-center'
        },
        {
          field: 'yearEnd',
          label: 'Year End',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'reason',
          label: 'Reason',
          sortable: false
        },
        {
          field: 'isInactive',
          label: 'Inactive?',
          sortable: false,
          class: 'custom-column-60 text-center'
        }
      ]
    },
    vehicles() {
      let _data = []
      _data.push({
        id: -9999,
        name: 'all',
        value: -9999
      })
      if (this.lookups['VehicleMake']) {
        this.lookups['VehicleMake'].forEach((element) => {
          _data.push(element)
        })
      }
      return _data
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getNoScrubList', 'getNoScrubItem', 'updateNoScrubItem', 'deleteNoScrubItem']),
    closeModal() {
      this.actionNoScrub = null
      this.actionDelete = null
    },
    refreshList() {
      this.getList()
    },
    setOrder(column, sortBy) {
      this.orderBy = column.field
      this.sortBy = sortBy
      this.getList()
    },
    async getList() {
      let options = {
        orderBy: this.orderBy,
        sortBy: this.sortBy,
        search: null,
        filter: this.filter === '-9999' ? null : this.filter,
        isInactive: this.showInactive
      }
      console.log('Refreshing No Scrub List', options)
      await this.getNoScrubList(options)
    },
    add() {
      this.updateNoScrubItem({
        name: 'new',
        value: null
      })
      this.updateNoScrubItem({
        name: 'vehicleMake',
        value: this.vehicleMake
      })
      this.actionNoScrub = {
        type: 'ADD'
      }
    },
    async edit(item) {
      console.log('Editing No Scrub item', item)
      this.getNoScrubItem(item.adasNoScrubList)
      this.actionNoScrub = {
        type: 'EDIT'
      }
    },
    async savedNoScrub() {
      await this.getList()
      this.closeModal()
    },
    confirmDelete(item) {
      this.actionDelete = item
    },
    async performDelete(item) {
      this.actionDelete = null
      console.log('Deleting No Scrub', item)
      await this.deleteNoScrubItem(item.adasNoScrubList)
      await this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}
.custom-row {
  margin: 0 !important;
}
.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.1em;
}
.listingWrapper {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 430px;
  width: 100%;
}
.custom-show-checkbox {
  position: relative;
  top: 5px;
}
</style>
